// src/components/Landing/HowToUseSection.js
import React, { useEffect, useRef } from 'react';
import './HowToUseSection.css';

export function HowToUseSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const steps = [
    {
      number: '01',
      title: 'Access the Platform',
      description: 'Click "Launch App" to open Supply Chain Brutus in your browser. No downloads or installation required.'
    },
    {
      number: '02',
      title: 'Create Your Account',
      description: 'Sign up with your OSU email for personalized learning tailored to your enrolled courses.'
    },
    {
      number: '03',
      title: 'Start Asking Questions',
      description: 'Type your supply chain questions directly or explore the guided tutorials and study materials.'
    },
    {
      number: '04',
      title: 'Learn and Practice',
      description: 'Get instant feedback, detailed explanations, and practice problems to reinforce your understanding.'
    }
  ];

  return (
    <section className="steps" ref={sectionRef}>
      <div className="container">
        <div className="section-header reveal">
          <span className="section-label">Getting Started</span>
          <div className="section-rule"></div>
        </div>
        <div className="steps-list">
          {steps.map((step, index) => (
            <div key={step.number} className={`step-item reveal reveal-delay-${index + 1}`}>
              <div className="step-num">{step.number}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-desc">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
